module.exports = __webpack_public_path__ + "img/53.803874e.png";